import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ModalPassword from '../../ModalPassword';

import { StyledBoxContainerFile, StyledWithholding } from './style';

const WithholdingFile = ({
  year,
  pdf,
  modalPassword,
  checkPassword,
  errorPassword,
  errorMessage,
  resetErrorMessage
}) => (
  <StyledWithholding>
    {!errorMessage && modalPassword && (
      <ModalPassword
        action={value => checkPassword(value)}
        resetErrorMessage={resetErrorMessage}
        errorPassword={errorPassword}
        labelTitle="Confirma tu Documento de Identidad"
        labelContent="Introduce tu DNI para mostrar el contenido"
        labelPlaceHolder="Documento de Identidad"
        labelPasswordIncorrect="DNI incorrecto"
        labelButton="Mostrar"
      />
    )}
    {!modalPassword && !errorMessage && pdf && pdf.length > 0 && (
      <StyledBoxContainerFile className="mb-30">
        <iframe
          src={pdf}
          title={`certificado${year}`}
          frameBorder="0"
          style={{
            overflow: 'hidden',
            overflowX: 'hidden',
            overflowY: 'hidden',
            height: '100%',
            width: '100%',
            position: 'absolute',
            top: '0px',
            left: '0px',
            right: '0px',
            bottom: '0px'
          }}
        />
      </StyledBoxContainerFile>
    )}
  </StyledWithholding>
);
WithholdingFile.propTypes = {
  year: PropTypes.string,
  modalPassword: PropTypes.bool,
  checkPassword: PropTypes.func,
  errorPassword: PropTypes.bool,
  employeeSelected: PropTypes.shape({
    text: PropTypes.string,
    value: PropTypes.number
  })
};

const mapStateToProps = state => ({
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(WithholdingFile);
